// app/javascript/controllers/timer_controller.js
import {Controller} from "@hotwired/stimulus"

// Cumulative phrases for the LLM-thinking gaps (when no tool event is firing).
const PHRASES = [
  { at: 0,  text: "Thinking…" },
  { at: 2,  text: "Reasoning through it…" },
  { at: 5,  text: "Digging deeper…" },
  { at: 10, text: "Connecting the dots…" },
  { at: 18, text: "Thinking deeper…" },
  { at: 30, text: "Almost there…" },
  { at: 45, text: "Refining the answer…" },
  { at: 65, text: "Final touches…" }
]

export default class extends Controller {
  static targets = ["display", "phrase"]

  connect() {
    this.startTime  = Date.now()
    this.running    = true
    this.lastPhrase = null
    this.updateDisplay()
    this.intervalId = setInterval(() => { if (this.running) this.updateDisplay() }, 200)
  }

  updateDisplay() {
    const elapsedSec = (Date.now() - this.startTime) / 1000

    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = `${elapsedSec.toFixed(1)}s`
    }

    if (this.hasPhraseTarget && this.phraseTarget.dataset.serverPhrase !== "true") {
      const phrase = this.pickPhrase(elapsedSec)
      if (phrase !== this.lastPhrase) {
        this.phraseTarget.textContent = phrase
        this.lastPhrase = phrase
      }
    }
  }

  pickPhrase(elapsedSec) {
    let chosen = PHRASES[0].text
    for (const p of PHRASES) {
      if (elapsedSec >= p.at) chosen = p.text
    }
    return chosen
  }

  stop() {
    this.running = false
    if (this.intervalId) { clearInterval(this.intervalId); this.intervalId = null }
    this.updateDisplay()
  }

  disconnect() { this.stop() }
}
